import React from 'react';
import { useTranslation } from 'react-i18next';

import { BodyText, Box } from '@chargify/custom-ui-components';
import { PaymentProfile } from '../../models/paymentProfile';
import PaymentProfileItem from './components/PaymentProfileItem/index';
import { Wrapper, List } from './PaymentProfilesReplace.styles';

type Props = {
  paymentProfiles: PaymentProfile[];
  onPaymentProfileSelected: (paymentProfile: PaymentProfile['id']) => void;
  selectedPaymentProfilesIds?: number[];
};
export const PaymentProfilesReplace = ({
  paymentProfiles,
  selectedPaymentProfilesIds,
  onPaymentProfileSelected,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  return (
    <Wrapper>
      <Box marginBottom={5}>
        <BodyText whiteSpace={'pre-line'}>
          {t('payment_profile.replace_payment_method_description')}
        </BodyText>
      </Box>
      <List>
        {paymentProfiles?.map((paymentProfile) => (
          <PaymentProfileItem
            isChecked={selectedPaymentProfilesIds?.includes(paymentProfile.id)}
            key={paymentProfile.id}
            paymentProfile={paymentProfile}
            onPaymentProfileSelected={() =>
              onPaymentProfileSelected(paymentProfile.id)
            }
          />
        ))}
      </List>
    </Wrapper>
  );
};
